/**
 * @ngdoc Directive
 * @name vrmGpsWidget
 * @example
 *
 * <vrmGpsWidget installation="installation" />
 *
 */
import { handleFileDownload } from "@/utils/download";

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmGpsWidget', vrmGpsWidget);

    /* @ngInject */
    function vrmGpsWidget() {

        return {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/gps-widget/gps-widget.template.html'),
            controller: controller,
            scope: {
                iconClass: '=',
                customName: '=',
                installation: '=',
                range: '=',
                widgetId: '=',
                isMobile: '=',
                hasTouchEnabled: '=',
                size: '=',
                itemState: '=?'
            }
        };

        /* @ngInject */
        function controller($scope, ApiService, moment) {
            let chartHeightMobile = '400px';
            /**
             * Get a field from the retrieved data
             * @param fieldName
             * @returns {*}
             */
            $scope.getField = function(fieldName) {
                if ($scope.data && $scope.data.records) {
                    return _.find($scope.data.records.data.attributes, {code: fieldName});
                } else {
                    return null;
                }
            };

            $scope.geofence = null;

            $scope.outsideSince = "";
            $scope.download = function() {
                ApiService.installationDownload($scope.installation.id, 'gps-download', {
                    start: $scope.range.startDate,
                    end: $scope.range.endDate
                }).then(function(response) {
                    handleFileDownload(response.data, 'gps.kml');
                });
            };

            $scope.$watch('size', () => {
                if (!$scope.chart || !$scope.chart.getHighcharts) return;
                $scope.chart.getHighcharts().reflow();
            });

            $scope.clickExpand = () => {
                if ($scope.itemState) $scope.itemState.expanded = !$scope.itemState.expanded;
            }

            $scope.$watch('installation', function(installation) {
                if (installation != null) {
                    $scope.now = Math.floor(Date.now() / 1000);

                    $scope.map = {
                        control: {},
                        center: {
                            latitude: installation.data.lt ? installation.data.lt.rawValue : null,
                            longitude: installation.data.lg ? installation.data.lg.rawValue : null
                        },
                        coords: {
                            latitude: installation.data.lt ? installation.data.lt.rawValue : null,
                            longitude: installation.data.lg ? installation.data.lg.rawValue : null
                        },
                        zoom: 7,
                        options: {
                            // Style
                            styles: [{
                                stylers: [{
                                    visibility: "simplified"
                                }]
                            }],

                            // Control buttons
                            mapTypeControl: true,
                            panControl: false,
                            zoomControl: true,
                            scaleControl: false,
                            rotateControl: false,
                            streetViewControl: false,
                            overviewMapControl: false,

                            scrollwheel: true

                        },
                    };

                    ApiService.installations(installation.id, 'widgets/GPS').then(function(response) {
                        $scope.data = response.data;
                        if ($scope.map.coords.latitude == $scope.map.center.latitude && $scope.map.coords.longitude == $scope.map.center.longitude) {
                            $scope.map.center.latitude = $scope.getField('lt') ? $scope.getField('lt').value : null;
                            $scope.map.center.longitude = $scope.getField('lg') ? $scope.getField('lg').value : null;
                        }
                        $scope.map.coords.latitude =  $scope.getField('lt') ? $scope.getField('lt').value : null;
                        $scope.map.coords.longitude = $scope.getField('lg') ? $scope.getField('lg').value : null;

                        try {
                            $scope.geofence = JSON.parse(response.data.records.data.geofence);
                        } catch (e) {
                            // Invalid geofence
                        }

                        $scope.outsideSince = "";
                        if ($scope.data.records.data.geofenceAlarmActive)
                        {
                            $scope.outsideSince = $scope.data.records.data.geofenceAlarmActive
                        }
                    });
                }
            });
        }
    }
})();
